// extracted by mini-css-extract-plugin
export var fadeInAnimation = "ReviewPlatform-module--fadeInAnimation--76fb6";
export var reviewPlatform = "ReviewPlatform-module--reviewPlatform--2c847";
export var reviewPlatformIcon = "ReviewPlatform-module--reviewPlatformIcon--870ee";